import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getCouponRepository } from '../../../domains/coupon';

// 이벤트 만들기 · 타겟 그룹 관리 — 템플릿/질병/추천 타겟/저장 그룹 (약국 토큰 필수 API)
const repo = () => getCouponRepository() as any;

const unwrap = (res: any) => {
  if (res?.result_code !== '200') throw new Error(res?.result_msg || '요청에 실패했습니다.');
  return res;
};

const KEYS = {
  templates: ['coupon-templates'],
  conditions: ['coupon-conditions'],
  recommended: ['coupon-target-groups-recommended'],
  groups: ['coupon-target-groups'],
};

export const useCouponTemplates = () =>
  useQuery({
    queryKey: KEYS.templates,
    queryFn: async () => (unwrap(await repo().getTemplates()).list ?? []) as any[],
  });

export const useCouponConditions = () =>
  useQuery({
    queryKey: KEYS.conditions,
    queryFn: async () => (unwrap(await repo().getConditions()).data?.groups ?? []) as any[],
  });

export const useRecommendedTargetGroups = () =>
  useQuery({
    queryKey: KEYS.recommended,
    queryFn: async () => (unwrap(await repo().getRecommendedTargetGroups()).list ?? []) as any[],
  });

export const useTargetGroups = () =>
  useQuery({
    queryKey: KEYS.groups,
    queryFn: async () => (unwrap(await repo().getTargetGroups()).list ?? []) as any[],
  });

const useRepoMutation = (fn: (arg: any) => Promise<any>, invalidate: string[][]) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (arg: any) => unwrap(await fn(arg)).data,
    onSuccess: () => invalidate.forEach((queryKey) => qc.invalidateQueries({ queryKey })),
  });
};

/** id 가 있으면 PUT, 없으면 POST */
export const useSaveTargetGroup = () =>
  useRepoMutation(
    ({ id, ...body }) => (id ? repo().updateTargetGroup(id, body) : repo().createTargetGroup(body)),
    [KEYS.groups]
  );

export const useDeleteTargetGroup = () =>
  useRepoMutation((id) => repo().deleteTargetGroup(id), [KEYS.groups, KEYS.templates]);

export const useCreateCouponTemplate = () =>
  useRepoMutation((body) => repo().createTemplate(body), [KEYS.templates]);

export const useDeleteCouponTemplate = () =>
  useRepoMutation((id) => repo().deleteTemplate(id), [KEYS.templates]);
